import client from "../client";

export async function getBlackout(blackoutId: string) {
	try {
		const res = await client(`/v1/blackouts/${blackoutId}`, {
			method: "GET",
			version: "Vehicle",
		});
		return res.data;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function saveBlackout(payload: {
	blackoutStartTime: Date;
	blackoutEndTime: Date;
	reason: string;
	blackoutVehicles: { vehicleId: string }[];
	csvFile: string | null;
	id?: string;
}) {
	try {
		const res = await client("/v1/blackouts", {
			method: payload.id ? "PUT" : "POST",
			version: "Vehicle",
			data: payload,
		});
		return res;
	} catch (error) {
		console.error(error);
		throw error;
	}
}
